const Immersive3dTourPropertyTypeLabel = ["Residential", "Commercial"];

export default Immersive3dTourPropertyTypeLabel;
